<template>
  <v-app id="inspire">
    <router-view
      :rulesEmail="rulesEmail"
      :rulesPassword="rulesPassword"
      :rulesDisplayname="rulesDisplayname"
      :rulesRole="rulesRole"
      :rulesCharcacters50="rulesCharcacters50"
      :rulesCharcacters100="rulesCharcacters100"
      :rulesCharcacters1000="rulesCharcacters1000"
    />

    <auto-logout />
  </v-app>
</template>

<script>
import _ from 'lodash'

// import { constantRoutes } from '@/router'

import AutoLogout from '@/components/idle/auto-logout.vue'
export default {
  components: {
    AutoLogout
  },
  props: {},
  data() {
    return {
      rulesEmail: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      rulesPassword: {
        required: value => !!value || 'Required.'
      },
      rulesDisplayname: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 characters',
        max: v => v.length < 51 || 'Max 50 charcacters'
      },
      rulesRole: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 characters',
        max: v => v.length < 51 || 'Max 50 charcacters',
        name: value => {
          const pattern = /^[a-zA-Z0-9]+$/
          return pattern.test(value) || 'Invalid Name.'
        }
      },
      rulesCharcacters50: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 charcacters',
        max: v => v.length < 51 || 'Max 50 charcacters'
      },
      rulesCharcacters100: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 charcacters',
        max: v => v.length < 101 || 'Max 100 charcacters'
      },
      rulesCharcacters1000: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 charcacters',
        max: v => v.length < 1001 || 'Max 1000 charcacters'
      }
    }
  }
}
</script>
